import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import { toast } from "react-toastify";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export async function updateParent(uid: string, name: string, disabled_attributes: string[]) {
    try{
        if (!uid) throw new Error("Parent not selected")
        if (!name || name.trim() === "") throw new Error("Parent not selected")
        
        const data: any = {
            uid, 
            name
        }

        if(disabled_attributes.length>0) data.disabled_attributes = disabled_attributes.join(',')

        let res = await ServiceWrapper.doPut(
            api_base_url + 'product/edit_parent',
            data,
            null,
            AuthManager.getGmsToken()
        );

        // error check
        if(res?.errorfound || !res.data?.data) throw new Error("Product update failed : " + (res?.data?.message ? res.data.message : "Unexpected error"))

        return res?.data ?? null
    }
    catch(err: any){
        return Promise.reject(new Error(err.message))
    }
}

export async function createParent(categoryid: string, name: string, variants: string[], disabledAttributes: string[]) {
    try{
        if(!categoryid) throw new Error("Category not found")
        if(variants.length === 0) throw new Error("Select at least one product")
        if(!name.trim()) throw new Error("Name should not be empty")

        const data: any = {
            category: categoryid,
            name: name,
            variants: variants,
        }
        if(disabledAttributes.length> 0) data.disabled_attributes = disabledAttributes.join(',')

        const res = await ServiceWrapper.doPost(
            api_base_url + "product/create_parent",
            data,
            null,
            AuthManager.getGmsToken()
        )
    
        // error check
        if(res?.errorfound || !res.data?.data) throw new Error("Failed to create parent : " + (res?.data?.message ? res.data.message : "Unexpected error"))
    
        return [true, res?.data ?? null]
    }
    catch(err: any){
        toast.error(err.message)
        return [false, null]
    }
}

export async function getParentById(parentId: string) {
    try{
        if(!parentId) throw new Error("No parent id specified")

        // call api
        let res = await ServiceWrapper.doGet(
            `${api_base_url}parent/${parentId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        // error check
        if(res?.errorfound || !res.data?.data) throw new Error("Parent fetch failed : " + (res?.data?.message ? res.data.message : "Unexpected error"))
        
        return res?.data
    }
    catch(err: any) {
        console.error((err.message), 8)
        return Promise.reject(new Error(err.message))
    }
  }

  export async function deleteParentById(parentId: string) {
    try{
        if(!parentId) throw new Error("No parent id specified")

        const res = await ServiceWrapper.doDelete(
            api_base_url + "/product/remove_parent/" + parentId,
            null,
            null,
            AuthManager.getGmsToken()
        )

        // error check
        if(res?.errorfound || !res.data?.done || res.data.error) throw new Error("Parent fetch failed : " + (res?.data?.message ? res.data.message : "Unexpected error"))
        
        return res?.data
    }
    catch(err: any) {
        console.error((err.message), 8)
        return Promise.reject(new Error(err.message))
    }
  }
